module.exports = {
  "/": {},
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/content": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/operations": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "operationsPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "FALLBACK_ERROR_CONTENT",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/interstitial": {
    "success": {
      "default": [
        "INTERSTITIAL_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "interstitialPage"
  },
  "/add-ons": {
    "success": {
      "default": [
        "ADD_ONS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "addOnsPage"
  },
  "/breeze-intelligence": {
    "success": {
      "default": [
        "BREEZE_INTELLIGENCE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "breezeIntelligencePage"
  },
  "/recommended": {
    "success": {
      "default": [
        "RECOMMENDED_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "recommendedPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  },
  "/hubspot-credits": {
    "success": {
      "default": [
        "HUBSPOT_CREDITS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "hubSpotCreditsPage"
  },
  "/internal-development": {},
  "/internal-development/marketing": {
    "success": {
      "default": [
        "MARKETING_HUB_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentMarketingPage"
  },
  "/internal-development/sales": {
    "success": {
      "default": [
        "SALES_HUB_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentSalesPage"
  },
  "/internal-development/service": {
    "success": {
      "default": [
        "SERVICE_HUB_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentServicePage"
  },
  "/internal-development/content": {
    "success": {
      "default": [
        "CONTENT_HUB_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentContentPage"
  },
  "/internal-development/data": {
    "success": {
      "default": [
        "DATA_HUB_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentDataPage"
  },
  "/internal-development/add-ons": {
    "success": {
      "default": [
        "ADD_ONS_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "internalDevelopmentAddOnsPage"
  },
  "/internal-development/suite": {
    "success": {
      "default": [
        "CUSTOMER_PLATFORM_PAGE"
      ],
      "redirect PROD to legacy marketing page": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "customerPlatformPage"
  }
};